import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import { useEffect, useMemo, useState } from "react";
import BasicButton from "components/button/BasicButton";
import { sendGet } from "api/restUtil";
import ReactDataTableDisplay from "components/DataTable/ReactDataTableDisplay";
import BranchHolidayMgmtModal from "./BranchHolidayMgmtModal";
import { getTodayStr } from "js/common";

/**
 * 지점 휴일 목록 팝업
 */
function BranchHolidayListModal (props) {

	const { isOpen, onClose, initData, modalId, title } = props;
	const [ holidayData, setHolidayData ] = useState([]);
	const [ isOpenAddModal, setIsOpenAddModal ] = useState(false);
	const [ isOpenModModal, setIsOpenModModal ] = useState(false);
	const [ addInitData, setAddInitData ] = useState({});
	const [ modInitData, setModInitData ] = useState({});


	// 휴일 수정 팝업
	const modDataPop = (data) => {
		setModInitData({...initData, ...data});
		setIsOpenModModal(true);
	}

	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "휴일", col : "holiday", cellWidth: "100"},
		{ header : "휴일유형", col : "type", cellWidth: "100"},
		{ header : "활성여부", col : "activationYnStr", cellWidth : "100"},
		{ header : "수정", col : "holiday", cellWidth : "50", type: "modButton", onClick: modDataPop},
	], []);
	

	useEffect(() => {
		if(!isOpen) {
			setHolidayData([]);
			return;
		};
		if(isOpen) {
			searchBranchHolidayList(initData);
			setAddInitData({...initData});
		}
	}, [isOpen]);


	const searchBranchHolidayList = async(param) => {
		let result = await sendGet("/api/mgmt/branch/" + param.branchId + "/holiday");
		if(result.respCode === "SUCCESS") {
			
			// const dataList = result.data;
			const today = getTodayStr();
			// 오늘 날짜 이후, 날짜 역순 / type 역순(배달->픽업 순)
			const dataList = result.data.filter(d => d.holiday >= today).sort((a,b) => {
				if(a.holiday > b.holiday) return -1;
				else if(a.holiday < b.holiday) return 1;
				else if(a.type > b.type) return -1;
				else if(a.type < b.type) return 1;
				return 0;
			});
			dataList.forEach(data => {
				if(data.activationYn) {
					data.activationYnStr = "Y";
				} else {
					data.activationYnStr = "N";
				}
				data.branchName = initData.branchName;
				data.branchId = initData.branchId;
			});
			setHolidayData(dataList);
		}
	}


	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal">

				<div className="me-modal-container" style={{width: "600px", height: "500px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "auto"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="body-area modal-form" id="branchAreaMgmtModal">
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>지점 ID</th>
											<td>
												{initData.branchId}
											</td>
										</tr>
										<tr>
											<th>지점 명</th>
											<td>
												{initData.branchName}
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div className="table-buttons mg-t-5 mg-b-5">
								<BasicButton
									label="추가"
									className="btn-add"
									onClick={() => setIsOpenAddModal(true)}
								/>
							</div>
							<ReactDataTableDisplay
								dataTableId="branchHolidayList"
								columns={columns}
								customDatas={holidayData}
								hideCheckBox={true}
								percentageWidth={true}
								// maxHeight="250px"
							/>

						</div>

						<div className="me-modal-footer mg-t-10 mg-b-20">
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="닫기" className="btn-save" onClick={onClose} style={{width: "100%"}} />

							</div>
						</div>

						{/* 등록 팝업 */}
						<BranchHolidayMgmtModal
							isOpen={isOpenAddModal}
							onClose={() => {searchBranchHolidayList(initData); setIsOpenAddModal(false);}}
							initData={addInitData}
							/>
						{/* 수정 팝업 */}
						<BranchHolidayMgmtModal
							isOpen={isOpenModModal}
							onClose={() => {searchBranchHolidayList(initData); setIsOpenModModal(false);}}
							initData={modInitData}
						/>

					</div>

				</div>
			</div>

		</ReactModal>
	);
}

export default BranchHolidayListModal;
